import { Uploader } from "rsuite";
import { createLogger } from '../../../utils/logger';
import "./_add-static-files.scss";
import { FileType } from "rsuite/esm/Uploader";

const logger = createLogger('static-files');

interface IProps {
  onSetEditStatic: () => void;
  onUploads: (file: File) => void;
}

export default function StaticModal({ onSetEditStatic, onUploads }: IProps) {
  const handleClose = (event: React.MouseEvent) => {
    // Закриваємо модалку, тільки якщо клік був здійснений на задній фон
    if (event.target === event.currentTarget) {
      onSetEditStatic();
    }
  };

  const uploadStatic = (fileList: FileType[]) => {
    const selected = [...(fileList || [])]
      .reverse()
      .map((file) => file?.blobFile || null)
      .find(Boolean) as File | null;

    logger.debug('static modal fileList', {
      files: (fileList || []).map((file) => ({
        name: file?.name || null,
        hasBlob: Boolean(file?.blobFile),
        size: typeof file?.blobFile?.size === 'number' ? file.blobFile.size : null,
      })),
      selectedName: selected?.name || null,
    });

    if (selected) {
      onSetEditStatic();
      onUploads(selected);
    }
  };

  return (
    <div className="drag_modal_wrap" onClick={handleClose}>
      <div className="drag_modal" onClick={(e) => e.stopPropagation()}>
        <Uploader
          action=""
          autoUpload={false}
          multiple={false}
          accept=".zip,application/zip,application/x-zip-compressed"
          onChange={uploadStatic}
          draggable
          onRemove={(file) => {
            logger.info(`File removed: ${file.name}`);
            // Тут можна видалити файл з IndexedDB, якщо потрібно
          }}
        >
          <div
            style={{
              height: 200,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span>
              Натисніть або перетягніть файли в цю область, щоб завантажити
            </span>
          </div>
        </Uploader>
      </div>
    </div>
  );
}
